import { get, update } from '@/services/internal/facility/config/AllowMoreBillForSameStoreConfig';

export default {
  namespace: 'allowMoreBillForSameStoreConfig',
  state: {
    data: {},
  },

  effects: {
    *update({ payload, callback }, { call }) {
      const response = yield call(update, payload);
      if (callback) callback(response);
    },

    *get({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      if (callback) callback(response);
    },
    reducers: {},
  },
};
